var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAsterisk(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "kij67wgd5a"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.300000 0 0 0 0 0.708333 0 0 0 0 1.000000 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#kij67wgd5a)",
    transform: "translate(-865 -146) translate(865 140)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M17.417 8.034c0-.357-.309-.646-.689-.646h-3.95c-.06 0-.117-.03-.148-.08-.03-.05-.03-.112 0-.162l1.975-3.207c.19-.309.077-.704-.252-.882l-1.79-.968c-.33-.179-.75-.073-.94.236L9.648 5.53c-.03.05-.087.08-.149.08s-.118-.03-.15-.08L7.377 2.323c-.19-.309-.61-.415-.94-.236l-1.79.968c-.33.178-.442.573-.252.882L6.37 7.144c.03.05.03.111 0 .161s-.087.081-.149.081h-3.95c-.38 0-.688.29-.688.646v1.936c0 .357.309.646.689.646h3.95c.06 0 .117.03.148.08.03.05.03.112 0 .162l-1.975 3.207c-.19.309-.077.704.252.882l1.79.968c.33.179.75.073.94-.236l1.975-3.207c.03-.05.088-.08.15-.08.06 0 .118.03.149.08l1.974 3.207c.19.309.611.415.94.236l1.79-.968c.33-.178.442-.573.252-.882l-1.974-3.207c-.03-.05-.03-.111 0-.161s.087-.081.149-.081h3.946c.38 0 .689-.29.689-.646V8.034z",
    transform: "translate(0 6)"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsterisk);
export default __webpack_public_path__ + "static/media/asterisk.30f6dd87.svg";
export { ForwardRef as ReactComponent };